module.exports = __webpack_public_path__ + "static/AvenirNext-Regular-aa36978d6b4150d0ec241c530162465a.woff2";